import { render, staticRenderFns } from "./SlideSearchResultItem.vue?vue&type=template&id=9190ab9a&scoped=true&"
import script from "./SlideSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./SlideSearchResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearchResultItem.vue?vue&type=style&index=0&id=9190ab9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9190ab9a",
  null
  
)

export default component.exports